export default "__VITE_ASSET__KQsWBO4c__"